import { Component, OnInit } from '@angular/core';
import * as lodash from 'lodash';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { EvaluationsService } from '../../../services/evaluations.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AlertService } from '../../../services/alert.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-club-evaluation-details',
  templateUrl: './evaluation-details.component.html',
  styleUrls: ['./evaluation-details.component.css']
})
export class ClubEvaluationDetailsComponent implements OnInit {
  addCategoryOpened: boolean;
  addQuestionOpened: boolean;

  public numberOfSelectedQuestions: number;
  public selectedQuestionsRecordIndex = [];
  public numberOfSelectedCategories: number;
  public selectedCategoriesRecordIndex = [];

  public isCategoryPopUp: boolean = false;

  showQuestions: boolean = false;
  showPresetQuestions: boolean = false;
  showCustomQuestion: boolean = false;

  public selectedPresetCategories = [];
  public selectedPresetQuestionIndex = [];
  public isSelectAllCheckBox = false;
  public isCheckAllCheckBox = false;

  isOpenConfirmDeletePopup: boolean;
  isConfirmWarning: boolean;
  namesToBeDeleted: string = '';
  alphaNumericPattern = /^[a-zA-Z ]+$/;

  popupConfirmForm: FormGroup;

  clubID: number;
  userID: number;

  public routeParams;
  public evaluationTemplateID: number;
  public evaluationTemplateDetails: any;
  public allQuestions: any[];
  public allCategories: any[];
  public totalCategories: number;
  public totalQuestions: number;
  public preSetCategories: any[];
  public preSetQuestions: any[];
  public evaluationTemplateName: '';

  public newCategoryName = '';
  public newQuestionName = '';
  public newQuestionRequired = false;

  public isCodeDiscountFormTabActive = false;
  public isSiblingDiscountFormTabActive = false;
  public isEarlyBirdDiscountFormTabActive = false;


  public reverse = false;
  public sortValue = 'question'; // Default Sorting Value

  public questionToCategoryPayload = {
    EvaluationCategoryID: 0,
    Questions: [],
    AddedBy: 0,
    IsCustom: false
  };

  public categoryToEvaluationPayload = {
    EvaluationTemplateID: 0,
    Categories: [],
    AddedBy: 0,
    IsCustom: false
  };

  public preSetQuestionForm: FormGroup;

  enableEditCategory: boolean;
  enableEditCategoryIndex: null;
  updatedCategoryName: null;

  enableEditQuestion: boolean;
  enableEditQuestionIndex: null;
  updateQuestion: any;

  public filteredPresetQuestions: any;

  public _links = [
    { title: 'Evaluation Templates', url: "/club-evaluation/templates" },
    { title: 'Details', url: null }
  ];

  constructor(
    private _service: EvaluationsService,
    private _loadingService: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private _activedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.popupConfirmForm = this.fb.group({
      confirm_program_delete: [null]
    });

    this.clubID = +localStorage.getItem('clubId');
    this.userID = +localStorage.getItem('userId');

    this.routeParams = this._activedRoute.snapshot.params;
    this.evaluationTemplateID = this.routeParams.id;

    this.preSetQuestionForm = this.fb.group({
      Questions: this.fb.array([])
    });
  }

  patchPreSetQuestions(categoryId, presetCategoryID) {
    // this.filteredPresetQuestions = {};

    const usedQuestions = this.allQuestions.filter(n => n.evaluationCategoryID == categoryId).map(l => l.question);
    // console.log("EXISTING QUESTIONS == ", usedQuestions);
    let filteredQuestions = this.preSetQuestions.filter(x => !usedQuestions.includes(x.question));
    // console.log("FILTERED QUESTIONS == ", filteredQuestions);

    if (presetCategoryID != 0) {
      filteredQuestions = filteredQuestions.filter(n => n.evaluationPresetCategoryID == presetCategoryID);
    }

    let filteredFiltered = [];

    filteredQuestions.map(x => filteredFiltered.push({
      questionChecked: false,
      evaluationPresetQuestionID: x.evaluationPresetQuestionID,
      question: x.question,
      required: false
    }));

    this.filteredPresetQuestions = filteredFiltered;


    //Reset questions
    this.preSetQuestionForm.setControl('Questions', new FormArray([]));

    const control = <FormArray>this.preSetQuestionForm.get('Questions');
    this.filteredPresetQuestions.forEach(x => {
      control.push(this.fb.group({
        questionChecked: x.questionChecked,
        evaluationPresetQuestionID: x.evaluationPresetQuestionID,
        question: x.question,
        required: x.required
      }));
    });

    //console.log('CONTROL   ===   ', control.value);
  }

  enableEditCategoryInline(e, i, categoryName) {
    //console.log('HERE');
    this.enableEditCategory = true;
    this.enableEditCategoryIndex = i;
    this.updatedCategoryName = categoryName;
    //console.log(i + ' = ' + categoryName);
    this.resetQuestionUpdateData();
  }

  enableEditQuestionInline(e, i, question) {
    //console.log('HERE');
    this.enableEditQuestion = true;
    this.enableEditQuestionIndex = i;
    this.updateQuestion = question;
    this.resetCategoryUpdateData();
    //console.log(i + ' = ' + question.question);
  }

  saveInlineEditedQuestion(e, questionId) {
    this._loadingService.show();
    //console.log(questionId + ' - ' + this.updateQuestion.question + ' - ' + this.updateQuestion.isRequired);
    const payload = {
      question: this.updateQuestion.question,
      updatedBy: this.userID,
      isRequired: this.updateQuestion.isRequired
    };

    console.log("Question ID == ", questionId);
    console.log("Payload == ", payload);

    this._service.updateQuestionDetails(questionId, payload).subscribe(data => {
      this.resetQuestionUpdateData();
      // this._loadingService.hide();
      this.enableEditQuestionIndex = null;
      this._alertService.success('Question updated successfully');
      this.loadEvaluationTemplateDetails();
    }, error => {
      this._loadingService.hide();
      this._alertService.error('Question could not be updated');
    })
  }

  updateCategoryName(id) {
    const payload = {
      name: this.updatedCategoryName,
      updatedBy: this.userID,
    };

    this._service.updateCategoryName(id, payload).subscribe(data => {
      this.resetCategoryUpdateData();
      this.loadEvaluationTemplateDetails();
      this._alertService.success('Category name updated successfully.');
    }, error => {
      this._alertService.error('Category name could not be updated');
    });
  }

  resetCategoryUpdateData() {
    this.enableEditCategory = false;
    this.enableEditCategoryIndex = null;
    this.updatedCategoryName = null;
  }

  resetQuestionUpdateData() {
    this.updateQuestion = null;
    this.enableEditQuestion = false;
    this.enableEditQuestionIndex = null;
    this.updateQuestion = null;
  }


  categoryNotInUse(evaluationPresetCategoryID) {
    return this.allCategories.filter(n => n.evaluationPresetCategoryID === evaluationPresetCategoryID).length != 0;
  }

  ngOnInit() {
    //Load Evaluation Template Details
    this.loadEvaluationTemplateDetails();
  }

  addCategory() {
    this.addCategoryOpened = true;
  }

  addQuestion() {
    this.addQuestionOpened = true;
    this.showCustomQuestion = false;
    this.showPresetQuestions = false;
    this.showQuestions = false;
  }

  resetOptionalButtons() {
    this.selectedPresetCategories.length = 0;
    this.selectedPresetQuestionIndex.length = 0;
    this.selectedCategoriesRecordIndex.length = 0;
    this.selectedQuestionsRecordIndex.length = 0;
    this.numberOfSelectedCategories = 0;
    this.numberOfSelectedQuestions = 0;
  }

  get list() {
    return [];
  }

  selectedCategory(i, e) {
    //console.log('Category  =>  ', i);
    if (e.target.checked) {
      this.selectedPresetCategories.push(i);
    } else {
      this.selectedPresetCategories.splice(
        this.selectedPresetCategories.indexOf(i),
        1
      );
    }
    //console.log('SELECTED  = ', this.selectedPresetCategories);
    // For enable status/delete button.
    // this.numberOfSelectedEvaluations = this.selectedRecordIndex.length;
  }

  selectedPresetQuestion(e, name, index) {
    const ctrls = this.preSetQuestionForm['controls']['Questions']['controls'][index]['controls'];
    //console.log('CTRLS = ', ctrls);

    if (e.target.checked) {
      this.selectedPresetQuestionIndex.push(name);
      ctrls['required'].patchValue('false');
    } else {
      this.selectedPresetQuestionIndex.splice(
        this.selectedPresetQuestionIndex.indexOf(name),
        1
      );
      ctrls['required'].patchValue('');
    }
    //console.log('SELECTED Question IDs = ', this.selectedPresetQuestionIndex);
  }

  onChangeAnswer(event, index, value) {
    const ctrls = this.preSetQuestionForm['controls']['Questions']['controls'][index]['controls'];
    if (event.target.checked) {
      console.log
      ctrls['required'].patchValue(value);
    }
  }

  /* Save in db */
  onSave(value) {

    const checkedQuestions = this.preSetQuestionForm.value.Questions.filter(n => n.questionChecked == true);
    const newArray = checkedQuestions.map(s => ({ question: s.question, required: s.required }));

    this.questionToCategoryPayload.Questions = newArray;
    this.questionToCategoryPayload.AddedBy = this.userID;
    this.questionToCategoryPayload.IsCustom = false;

    // console.log('this.questionToCategoryPayload => ', this.questionToCategoryPayload);

    this._loadingService.show();

    this.totalCategories = -1;
    this.totalQuestions = -1;

    // console.log('Questions Payload = ', this.questionToCategoryPayload);

    this._service
      .addQuestionToCategoryInEvaluationTemplate(this.questionToCategoryPayload)
      .subscribe(
        data => {
          this.addQuestionOpened = false;
          this.newQuestionName = '';
          this.newQuestionRequired = false;
          this._loadingService.hide();
          this._alertService.success('New category added to template');
          this.loadEvaluationTemplateDetails();
        },
        error => {
          this._loadingService.hide();
          this._alertService.error('Category could not be added');
        }
      );
  }

  selectedQuestionsRecord(i, e) {
    if (e.target.checked) {
      this.selectedQuestionsRecordIndex.push(i);
    } else {
      this.selectedQuestionsRecordIndex.splice(this.selectedQuestionsRecordIndex.indexOf(i), 1);
    }
    this.numberOfSelectedQuestions = this.selectedQuestionsRecordIndex.length;
  }

  selectedCategoriesRecord(i, e) {
    if (e.target.checked) {
      this.selectedCategoriesRecordIndex.push(i);
    } else {
      this.selectedCategoriesRecordIndex.splice(this.selectedCategoriesRecordIndex.indexOf(i), 1);
    }
    this.numberOfSelectedCategories = this.selectedCategoriesRecordIndex.length;
  }

  closeOverlay(event = null) {
    if (event) {
      event.stopPropagation();
    }
    this.addCategoryOpened = false;
    this.addQuestionOpened = false;
  }

  onCancel(event = null) {
    this.addCategoryOpened = false;
    this.addQuestionOpened = false;
  }

  onCategorySelected(event) {
    if (event.target.value) {

      //console.log('event.target.value (evaluationPresetCategoryID) => ', event.target.value);
      //console.log('this.allCategories => ', this.allCategories);

      const category = this.allCategories.find(n => n.evaluationCategoryID == event.target.value);

      this.questionToCategoryPayload.EvaluationCategoryID = Number(
        category.evaluationCategoryID
      );

      // console.log("presetCategoryID == ", presetCategoryID);

      this.showCustomQuestion = true;
      this.showPresetQuestions = true;
      this.showQuestions = true;

      if (event.target.value == 3) {
        this.showCustomQuestion = false;
      }

      if (category.isCustom) {
        this.showPresetQuestions = false;
      }

      let presetCategoryID = 0;
      const presetCategory = this.preSetCategories.find(n => n.name == category.name);
      //console.log('=== presetCategoryID == ', presetCategoryID);

      if (presetCategory) {
        //console.log('PRESET CATEGORY =>>>>> ', presetCategory);
        presetCategoryID = presetCategory.evaluationPresetCategoryID;
      }

      this.patchPreSetQuestions(event.target.value, presetCategoryID);

    } else {
      this.showCustomQuestion = false;
      this.showPresetQuestions = false;
      this.showQuestions = false;
    }
  }

  removeSelectedQuestions() {
    const l = this.selectedQuestionsRecordIndex.length;
    const ids = this.selectedQuestionsRecordIndex.join(', ');
    //console.log('ID(s) = ', ids);

    var nameArray = this.allQuestions.filter(n => ids.includes(n.evaluationQuestionID)).map(n => n.question);
    //console.log('NAMES = ', nameArray)

    this.isOpenConfirmDeletePopup = true;
    this.isCategoryPopUp = false;
    this.namesToBeDeleted = nameArray.join(', ');
    //console.log('namesToBeDeleted == ', this.namesToBeDeleted);
    this.addConfirmFormValidation();
  }

  removeSelectedCategories() {
    const l = this.selectedCategoriesRecordIndex.length;
    const ids = this.selectedCategoriesRecordIndex.join(', ');
    //console.log('ID(s) = ', ids);

    var nameArray = this.allCategories.filter(n => ids.includes(n.evaluationCategoryID)).map(n => n.name);
    //console.log('Categories = ', nameArray)

    this.isOpenConfirmDeletePopup = true;
    this.isCategoryPopUp = true;
    this.namesToBeDeleted = nameArray.join(', ');
    //console.log('namesToBeDeleted == ', this.namesToBeDeleted);
    this.addConfirmFormValidation();
  }

  addNewCategory() {
    this.categoryToEvaluationPayload.EvaluationTemplateID = Number(
      this.evaluationTemplateID
    );

    const category = { evaluationPresetCategoryID: 0, name: this.newCategoryName };

    this.categoryToEvaluationPayload.Categories = [
      category
    ];

    this.categoryToEvaluationPayload.AddedBy = this.userID;
    this.categoryToEvaluationPayload.IsCustom = true;

    console.log('PAYLOAD == ', this.categoryToEvaluationPayload);

    this._loadingService.show();

    this._service
      .addCategoryToEvaluationTemplate(this.categoryToEvaluationPayload)
      .subscribe(
        data => {
          this.addCategoryOpened = false;
          this.newCategoryName = '';
          this._loadingService.hide();
          this._alertService.success('New category added to template');
          this.loadEvaluationTemplateDetails();
        },
        error => {
          this._loadingService.hide();
          this._alertService.error('Category could not be added to template');
        }
      );
  }

  addNewCategories() {

    // addNewCategories
    // console.log("this.selectedPresetCategories => ", this.selectedPresetCategories);

    this.categoryToEvaluationPayload.EvaluationTemplateID = Number(
      this.evaluationTemplateID
    );
    this.categoryToEvaluationPayload.Categories = this.selectedPresetCategories;
    this.categoryToEvaluationPayload.AddedBy = this.userID;
    this.categoryToEvaluationPayload.IsCustom = false;

    this._loadingService.show();

    this._service
      .addCategoryToEvaluationTemplate(this.categoryToEvaluationPayload)
      .subscribe(
        data => {
          this.addCategoryOpened = false;
          this.newCategoryName = '';
          this._alertService.success('New category added to template');
          this.loadEvaluationTemplateDetails();
        },
        error => {
          this._loadingService.hide();
          this._alertService.error('Category could not be added');
        }
      );
  }

  addNewQuestions() {

    this.questionToCategoryPayload.Questions = this.selectedPresetQuestionIndex;
    this.questionToCategoryPayload.AddedBy = this.userID;
    this.questionToCategoryPayload.IsCustom = false;
    this._loadingService.show();

    this.totalCategories = -1;
    this.totalQuestions = -1;

    //console.log('Questions Payload = ', this.questionToCategoryPayload);

    this._service
      .addQuestionToCategoryInEvaluationTemplate(this.questionToCategoryPayload)
      .subscribe(
        data => {
          this.addQuestionOpened = false;
          this.newQuestionName = '';
          this.newQuestionRequired = false;
          this._loadingService.hide();
          this._alertService.success('New category added to template');
          this.loadEvaluationTemplateDetails();
        },
        error => {
          this._loadingService.hide();
          this._alertService.error('Category could not be added');
        }
      );
  }

  addNewQuestion() {
    this.questionToCategoryPayload.AddedBy = this.userID
    if (this.newQuestionName) {
      this.questionToCategoryPayload.Questions.push({
        question: this.newQuestionName,
        required: this.newQuestionRequired
      })
      //= ["" + this.newQuestionName + ""];
    }
    this.questionToCategoryPayload.IsCustom = true;

    if (this.questionPayloadIsValid()) {
      this.totalCategories = -1;
      this.totalQuestions = -1;

      //console.log("this.questionToCategoryPayload =>", this.questionToCategoryPayload);

      this._loadingService.show();
      this._service
      .addQuestionToCategoryInEvaluationTemplate(this.questionToCategoryPayload)
      .subscribe(
        data => {
          this.addQuestionOpened = false;
          this.newQuestionName = '';
          this.newQuestionRequired = false;
          this.questionToCategoryPayload.Questions.length = 0;
          this._alertService.success('New question added to category');
          this.loadEvaluationTemplateDetails();
        },
        error => {
          this.questionToCategoryPayload.Questions.length = 0;
          this._loadingService.hide();
          this._alertService.error('Question could not be added to category');
        }
      );
    } else {
      this._alertService.warn('Please, select a category and provide a question');
    }
  }

  questionPayloadIsValid() {
    if (this.questionToCategoryPayload.AddedBy != 0 &&
      this.questionToCategoryPayload.EvaluationCategoryID &&
      this.questionToCategoryPayload.Questions.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  loadEvaluationTemplateDetails() {
    // this._loadingService.show();
    this._service
      .loadEvaluationTemplateDetails(this.evaluationTemplateID)
      .subscribe(
        (result: any) => {
          this.evaluationTemplateDetails = result;
          //console.log('DETAILS == ', this.evaluationTemplateDetails);

          this.allQuestions = result.data.allQuestions;
          this.allCategories = result.data.allCategories;
          this.totalCategories = result.data.totalCategories;
          this.totalQuestions = result.data.totalQuestions;
          this.preSetCategories = result.data.preSetCategories;
          this.preSetQuestions = result.data.preSetQuestions;
          this.evaluationTemplateName = result.data.evaluationTemplateName;

          this.resetPayloads();
          this.resetCategoryUpdateData();
          this.resetQuestionUpdateData();
          this._loadingService.hide();
        },
        error => {
          this._loadingService.hide();
          this._alertService.error(
            'Evaluation template details could not be loaded'
          );
        }
      );
  }

  resetPayloads() {
    //Reset Question Payload
    this.questionToCategoryPayload.EvaluationCategoryID = null;
    this.questionToCategoryPayload.Questions = [];
    this.questionToCategoryPayload.AddedBy = 0;
    this.selectedPresetQuestionIndex.length = 0;

    //Reset Category Payload
    this.categoryToEvaluationPayload.EvaluationTemplateID = 0;
    this.categoryToEvaluationPayload.Categories = [];
    this.selectedPresetCategories.length = 0;
  }

  getQuestionCategoryName(evaluationCategoryID): string {
    return this.allCategories.find(
      n => n.evaluationCategoryID == evaluationCategoryID
    ).name;
  }

  addEvaluation(f) {
    //console.log('ADD EVALUATION   ===   ', f);
  }

  setOrder(value: string) {
    this.reverse = !this.reverse;
    this.sortValue = value;
    const transacations = lodash.sortBy(this.allQuestions, value);
    this.allQuestions = this.reverse ? transacations.reverse() : transacations;
  }

  //START: CONFIRMATION
  addConfirmFormValidation() {
    const control = this.popupConfirmForm.get('confirm_program_delete');
    control.setValidators(
      Validators.compose([
        Validators.required,
        Validators.pattern(this.alphaNumericPattern)
      ])
    );
    control.updateValueAndValidity();
  }

  onPopUpConfirm() {
    const flag = this.isDeleteTextMatched();
    if (flag) {
      this._loadingService.show();
      if (this.isCategoryPopUp) {
        var categoryIDs = this.selectedCategoriesRecordIndex.join(',').split(',');
        //console.log('CATEGORY ID(s)  = ', categoryIDs);
        this._service.removeEvaluationCategories(categoryIDs).subscribe(
          result => {
            this.isConfirmWarning = false;
            this.resetOptionalButtons();
            this.closePopup();
            if (this.numberOfSelectedCategories > 1) {
              this._alertService.success('Categories removed successfully');
            } else {
              this._alertService.success('Category removed successfully');
            }
            this.loadEvaluationTemplateDetails();
          },
          error => {
            this._loadingService.hide();
            this.resetOptionalButtons();
            this.closePopup();
            this._alertService.error(error.error);
          }
        );
      } else {
        const questionIDs = this.selectedQuestionsRecordIndex.join(',').split(',');
        //console.log('QUESTION ID(s)  = ', questionIDs);
        this._service.removeEvaluationQuestions(questionIDs).subscribe(
          result => {
            this.isConfirmWarning = false;
            this.resetOptionalButtons();
            this.closePopup();
            this._alertService.success('Question(s) removed successfully');
            // this.resetOptionalButtons();
            this.loadEvaluationTemplateDetails();
          },
          (error) => {
            this._loadingService.hide();
            this.resetOptionalButtons();
            this.closePopup();
            this._alertService.error(error.error);
          }
        );
      }
    } else {
      this.isConfirmWarning = true;
    }
  }

  closePopup() {
    this.isOpenConfirmDeletePopup = false;
    this.isConfirmWarning = false;
    this.isCategoryPopUp = false;
    this.popupConfirmForm.reset();
    this.removeConfirmFormValidation();
  }

  removeConfirmFormValidation() {
    const control = this.popupConfirmForm.get('confirm_program_delete');
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  isDeleteTextMatched() {
    const val = this.popupConfirmForm.get('confirm_program_delete').value;
    if (val) {
      return val.trim() === 'REMOVE' ? true : false;
    }
  }

  isConfirmDeleteValid() {
    return (
      this.popupConfirmForm.get('confirm_program_delete').errors &&
      (this.popupConfirmForm.get('confirm_program_delete').touched ||
        this.popupConfirmForm.get('confirm_program_delete').dirty)
    );
  }

  validateUi() {
    Object.keys(this.popupConfirmForm.controls).forEach(field => {
      const control = this.popupConfirmForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  removeValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  requiredValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.enable();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }
  //END: CONFIRMATION
}



// WEBPACK FOOTER //
// ./src/app/pages/club-evaluations/evaluation-details/evaluation-details.component.ts